import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["scanInput", "display"]

  scan(event) {
    event.preventDefault()
    const input = this.scanInputTarget.value.trim()
    this.scanInputTarget.value = ''

    fetch('/pack_ship_station/scan', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content },
      body: JSON.stringify({ scan_input: input })
    })
    .then(r => r.json())
    .then(data => {
      if (data.success) {
        this.displayTarget.classList.remove('hidden')
        const actions = this.getActions(data.item.status)
        this.displayTarget.innerHTML = `
          <div class="bg-white p-6">
            <p class="mb-4">Order #${data.job.ordernumber} - Status: ${data.item.status}</p>
            ${actions.map(a => `<button data-item-id="${data.item.id}" data-action-type="${a.type}" data-action="click->pack-ship-station#updateStatus" class="mr-2 rounded-md bg-indigo-600 px-4 py-2 text-white">${a.label}</button>`).join('')}
          </div>
        `
      }
    })
  }

  getActions(status) {
    const map = {
      'QC Pass': [{type: 'start_packing', label: 'Start Packing'}],
      'Packing Started': [{type: 'packed', label: 'Mark Packed'}],
      'Packed': [{type: 'ready_to_ship', label: 'Ready To Ship'}],
      'Ready To Ship': [{type: 'shipped', label: 'Mark Shipped'}]
    }
    return map[status] || []
  }

  updateStatus(event) {
    const btn = event.currentTarget
    fetch('/pack_ship_station/update_status', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-CSRF-Token': document.querySelector('[name="csrf-token"]').content },
      body: JSON.stringify({ item_id: btn.dataset.itemId, action_type: btn.dataset.actionType })
    })
    .then(r => r.json())
    .then(data => {
      alert(data.message || data.error)
      this.displayTarget.classList.add('hidden')
      this.scanInputTarget.focus()
    })
  }
}
